<template>
  <el-dialog :title="title" width="550px" append-to-body destroy-on-close :modal="true" center :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="$emit('input',false)">
    <el-form ref="clueForm" :model="form" :rules="rules" label-width="80px" label-position="top" style="padding: 0 16px;">
      <el-row style="margin-bottom: 10px;" :gutter="20">
        <el-col :span="24">
          <el-form-item prop="time" :label="contentItem.label">

            <el-date-picker type="date" placeholder="请选择日期" v-model="form.time" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>



      <el-form-item style="display: flex;justify-content: end;">
        <el-button :loading="loading" type="primary" @click="onSubmit('clueForm')">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import CustomCardTable from "@/component/PrePayManage/dialog/CustomCardTable";
import CustomTool from "@/component/Performance/topTool/CustomTool";
import {
  addClient,
  addClue,
  addClueInfoContent,
  exportExcel,
  exportPerformanceDetail,
  exportProjectDetail,
  getClueOption, handleMessage
} from "@/api/api";
import {quotation_type} from "@/config";
export default {
  name: "addClientDialog",
  components:{
  },
  props:{
    value:{
      type: Boolean,
      default:false,
      required: true
    },
    title:{
      type:String
    },
    contentItem:{
      type:Object
    }
  },
  data() {
    return {
      loading:false,
      dialogFormVisible: false,
      refreshId:0,
      form:{
        time:""
      },
      rules: {
        // this_progress: [
        //     {required: true, validator: validateThisProgress}
        // ],
        time: [
          {required: true, message: `请选择${this.contentItem.label}`}
        ]
      }
    }
  },

  watch:{
    value(newVal){
      this.dialogFormVisible = newVal
      if(this.dialogFormVisible){
        this.refresh()
      }
    },

  },
  mounted() {

  },
  methods:{
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log('submit!',this.form);
          this.addContentAction()
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },

    async addContentAction(){
      this.loading = true
      let postData = {
        type:"part",

            id:this.contentItem.id,
            initial_id: this.contentItem.initial_id,
            business:this.contentItem.business,
            message_type:this.contentItem.message_type,
            user:this.contentItem.approver,
            business_id:this.contentItem.business_id,
            stat_time:this.contentItem.stat_time,
            new_time:this.form.time

      }
      // console.log('handleMessage',postData)
      let res = await handleMessage(postData)
      if(res.respCode&&res.respCode=='000000'){
        // console.log('handleMessage',res)
        this.$message.success(res.respMsg)
        this.$emit("updateList")
        this.$nextTick(()=>{
          this.$emit('input',false)
          this.loading = false
          this.form.time = ""
        })
      }else{
        this.$message.error(res.respMsg)
      }
    },

    refresh(content){
      this.refreshId +=1
    }
  }
}
</script>

<style scoped>

/deep/ .form-select.el-select{
  width: 100%;
}

/deep/ .el-dialog {
  display: flex;
  flex-direction: column;
  margin:0 !important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
  /*height:600px;*/
  max-height:calc(100% - 200px);
  max-width:calc(100% - 30px);
}
/deep/ .el-dialog .el-dialog__body {
  flex:1;
  overflow: auto;
}

</style>
